export const TITLE_SIZE = {
  small: "text-3xl",
  base: "text-4xl",
  large: "text-5xl",
} as const;

type ObjectValues<T> = T[keyof T];
export type TitleSizeType = ObjectValues<typeof TITLE_SIZE>

